<style lang="less">
@import "../../styles/public/public.less";

.Home_Head {
  color: #fff;
  width: 100%;
  height: 74px;
  .Home_Head1 {
    .display_column_jc;
    width: 100%;
    height: 74px;
    background-image: url("../../../static/images/head.png");
    .Home_Head_center {
      .Home_Head_center_cd {
        width: 130px;
        height: 35px;
        margin: 0px 5px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .Home_Head_center_cd:hover {
        background-image: url("../../../static/images/xz.png");
      }

      .Home_Head_center_cds {
        background-image: url("../../../static/images/xz.png");
      }
    }
    .Home_Head_right_wz {
      z-index: 1;
      position: absolute;
      border-right: 1px solid #4183bc;
      padding: 0px 10px 0px 0px;
      width: 100%;
      text-align: right;
    }

    .Home_Head_right_gb {
      z-index: 2;
      position: absolute;
      right: -35px;
      top: 2px;
    }
    .Home_Head_left {
      width: 544px;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 544px 100px;
      background-position: left;
      img {
        width: 500px;
        height: 60px;
        margin-left: 30px;
      }
    }
  }

  /* .Home_Head_all{
      width: 100%;
      height: 80px;
      background-image: url("../../../static/images/head.png");
    
    .Home_Head_left {
      width: 544px;
      height: 100%;
      // background-image: url("../../../static/images/left.png");
      background-repeat: no-repeat;
      background-size: 544px 100px;
      background-position: left;

      img {
        width: 388px;
        height: 54px;
        margin-left: 133px;
        margin-top: 26px;
      }
    }
    .Home_Head_center {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding: 9px 0px 26px 0px;

      .Home_Head_center_d {
        width: 100%;
        height: 100%;
        border-bottom: 1px solid rgb(25, 99, 134);
        padding: 0px 0% 0px 0px;
        // background: url("../../../static/images/head_center.png");
        background-size: 100% 100%;

        .Home_Head_center_cd {
          width: 130px;
          height: 35px;
          margin: 0px 5px;
          // background-image: url("../../../static/images/xz.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .Home_Head_center_cd:hover {
          background-image: url("../../../static/images/xz.png");
        }

        .Home_Head_center_cds {
          background-image: url("../../../static/images/xz.png");
        }

        .downInfo {
          // border:1px solid red;
          // height: 40px;
          padding-left: 10px;
          overflow-y: hidden;
          line-height: 30px;
          cursor: pointer;
          a:link {
            color: white;
          }
        }
        .shiftCol {
          animation-duration: 20s;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-direction: normal;
          animation-play-state: running;
          animation-name: myshiftcol;
          @keyframes myshiftcol {
            0% {
              transform: translate(0%, 0%);
              opacity: 1;
            }
            49.5% {
              transform: translate(0%, -100%);
              opacity: 1;
            }
            49.6% {
              transform: translate(0%, -100%);
              opacity: 0;
            }
            50.4% {
              transform: translate(0%, 100%);
              opacity: 0;
            }
            50.5% {
              transform: translate(0%, 100%);
              opacity: 1;
            }
            100% {
              transform: translate(0%, 0%);
              opacity: 1;
            }
          }
        }
        .shiftCol2 {
          animation-duration: 20s;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-direction: normal;
          animation-play-state: running;
          animation-name: myshiftcol2;
          @keyframes myshiftcol2 {
            0% {
              transform: translate(0%, 0%);
              opacity: 1;
            }
            49.5% {
              transform: translate(0%, -100%);
              opacity: 1;
            }
            99% {
              transform: translate(0%, -200%);
              opacity: 1;
            }
            99.1% {
              transform: translate(0%, -200%);
              opacity: 0;
            }
            99.9% {
              transform: translate(0%, 0%);
              opacity: 0;
            }
            100% {
              transform: translate(0%, 0%);
              opacity: 1;
            }
          }
        }
        .shiftbox {
          overflow-y: hidden;
          // height: 60px;
        }
        .shiftbox:hover {
          .shiftCol {
            animation-play-state: paused;
          }
          .shiftCol2 {
            animation-play-state: paused;
          }
        }
      }
    }
    .Home_Head_right {
      width: 310px;
      height: 100%;
      // background-image: url("../../../static/images/right.png");
      background-repeat: no-repeat;
      background-size: 310px 100px;
      background-position: right;
      position: relative;

      .Home_Head_right_wz {
        z-index: 1;
        position: absolute;
        right: 140px;
        top: 23px;
      }

      .Home_Head_right_gb {
        z-index: 2;
        position: absolute;
        right: 80px;
        top: 26px;
      }
    }
    

  } */
}
</style>
<template>
  <div class="Home_Head">
    <div class="Home_Head1">
      <Row style="margin-top:15px;">
        <Col span="9">
          <div class="Home_Head_left dispaly_flex00">
            <img src="../../../static/images/bt.png" />
          </div>
        </Col>
        <Col span="10" style="margin-top:8px;">
          <Modal v-model="showdown">
            <div>
              <div
                class="display_row_js_ac"
                style="text-align: center;height: 40px;border-top: 1px solid #8080801c;border-bottom: 1px solid #8080801c;"
              >
                <div style="width:20%">序号</div>
                <div style="width:80%">名称</div>
              </div>
              <div
                v-for="(item, index) in downdata"
                class="display_row_js_ac"
                style="height: 40px;text-align: center;border-bottom: 1px solid #8080801c;"
              >
                <div style="width:20%">{{ index + 1 }}</div>
                <div
                  style="width:80%;cursor:pointer;"
                  @click="exportfile(item.url)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div slot="header">
              <p>下载信息列表</p>
            </div>
          </Modal>
          <div class="Home_Head_center media_w_w20 dispaly_flex11">
            <div
              style="overflow-y:hidden;"
              class="Home_Head_center_d display_row_js_ac"
            >
              <div class="shiftbox">
                <div class="media_w_w16 downInfo">
                  <div class="display_row_js_ac">
                    <img
                      src="../../../static/images/ic_project.png"
                      style="height: 24px;margin-right:12px;"
                      @click="showdowninfo"
                    />
                    <span
                      style="margin-left: -6px;"
                      @click="exportfile(infobj.url)"
                      >{{ infobj.name }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="display_row_je_ac">
                <div
                  v-for="item in menu"
                  v-show="item.show"
                  class="Home_Head_center_cd display_row_jc_ac"
                  @click="click_Menu(item)"
                  :class="{ Home_Head_center_cds: item.judge }"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col span="4" style="margin-top:12px;">
          <div class="display_column_ae dispaly_flex00">
            <div class="Home_Head_right_wz media_w_w18">
              <samp>{{ this.$store.state.user.USERNAME }}</samp>
            </div>
            <img
              class="Home_Head_right_gb"
              src="../../../static/images/gb.png"
              @click="tuichu"
            />
          </div>
        </Col>
      </Row>
      <!-- <div class="Home_Head_left dispaly_flex00">
        <img src="../../../static/images/bt.png" />
      </div>
      <Modal v-model="showdown">
        <div>
          <div
            class="display_row_js_ac"
            style="text-align: center;height: 40px;border-top: 1px solid #8080801c;border-bottom: 1px solid #8080801c;"
          >
            <div style="width:20%">序号</div>
            <div style="width:80%">名称</div>
          </div>
          <div
            v-for="(item,index) in downdata"
            class="display_row_js_ac"
            style="height: 40px;text-align: center;border-bottom: 1px solid #8080801c;"
          >
            <div style="width:20%">{{index+1}}</div>
            <div style="width:80%;cursor:pointer;" @click="exportfile(item.url)">{{item.name}}</div>
          </div>
        </div>       
        <div slot="header">
          <p>下载信息列表</p>
        </div>
      </Modal>
      <div class="Home_Head_center media_w_w20 dispaly_flex11">
        <div style="overflow-y:hidden;" class="Home_Head_center_d display_row_js_ac">
          <div class="shiftbox">
            <div class="media_w_w16 downInfo">
              <div class="display_row_js_ac">
                <img
                  src="../../../static/images/ic_project.png"
                  style="height: 24px;margin-right:12px;"
                  @click="showdowninfo"
                />
                <span style="margin-left: -6px;" @click="exportfile(infobj.url)">{{infobj.name}}</span>
              </div>
            </div>
          </div>
          <div class="display_row_je_ac">
            <div
              v-for="item in menu"
              v-show="item.show"
              class="Home_Head_center_cd display_row_jc_ac"
              @click="click_Menu(item)"
              :class="{'Home_Head_center_cds':item.judge}"
            >{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="Home_Head_right dispaly_flex00">
        <div class="Home_Head_right_wz media_w_w18">
          <samp>{{this.$store.state.user.USERNAME}}</samp>
        </div>
        <img class="Home_Head_right_gb" src="../../../static/images/gb.png" @click="tuichu" />
      </div>-->
    </div>
    <div style="margin: 5px 0px 0px 5px;" v-show="ylj">
      <Tooltip content="统计信息">
        <img style="height: 30px" :src="this.imgurl" @click="showchange()" />
      </Tooltip>
    </div>
  </div>
</template>

<script>
import bus from "../../app/event";
import Cookies from "js-cookie";
export default {
  components: {},
  data() {
    return {
      ylj: true,
      infobj: infoConfig.infoList[0],
      timer: null,
      menu: [
        {
          judge: true,
          show: true,
          name: "项目管理",
          path: "/theme",
          children: ["/theme"]
        },
        {
          judge: false,
          show: true,
          name: "后台管理",
          path: "/unit",
          children: ["/unit", "/user"]
        }
      ],
      showtype: false,
      imgurl: "./static/images/staticimg2.png",
      showdown: false,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "名称",
          key: "name1",
          align: "center"
        }
      ],
      downdata: infoConfig.infoList,
      selection: []
    };
  },
  methods: {
    showdowninfo: function() {
      this.showdown = true;
      this.selection = [];
      this.downdata = [];
      this.downdata = infoConfig.infoList.concat([]);
    },
    getSelect: function(selection) {
      this.selection = selection;
    },
    canceldown: function() {
      this.showdown = false;
      this.selection = [];
    },
    confirmdown: function() {
      if (this.selection.length == 0) {
        this.$Message.warning("请选择下载内容");
        return;
      }
      this.selection.forEach((el, index) => {
        window.open(el.url, index);
      });
      this.showdown = false;
    },
    showchange: function() {
      this.showtype = !this.showtype;
      this.$store.state.staticShow = this.showtype;
      if (this.showtype == true) {
        this.imgurl = "./static/images/staticimg.png";
      } else {
        this.imgurl = "./static/images/staticimg2.png";
      }
    },
    click_Menu: function(item) {
      if (item) {
        if (item.name == "后台管理") {
          this.ylj = false;
        } else {
          this.ylj = true;
        }
        if (
          item.name == "后台管理" &&
          sessionStorage.getItem("AOTHOR_ID") == "1"
        ) {
          this.$router.push("/user");
        } else {
          this.$router.push(item.path);
        }
      }
      for (var i = 0; i < this.menu.length; i++) {
        var judge = this.menu[i].children.includes(this.$root._route.path);
        if (judge) {
          this.menu[i].judge = true;
        } else {
          this.menu[i].judge = false;
        }
      }
      for (let l = 0; l < this.menu.length; l++) {
        if (this.menu[l].judge == false && this.menu[l].name == "后台管理") {
          this.ylj = true;
        } else {
          this.ylj = false;
        }
      }
      //ylj 是判断【项目管理】，【后台管理】的显隐，在项目管理时，判断登录人员，给出显隐
      if (this.ylj) {
        if (sessionStorage.getItem("AOTHOR_ID") == "1") {
          this.ylj = false;
        }
      }
    },
    //退出
    tuichu: function() {
      Cookies.set("flog", false);
      this.$store.state.app = "n_login";
      this.$router.push("/theme");
    },
    //
    exportfile: function(url) {
      window.open(url);
    },
    changeInfo: function(index) {
      let count = 0;
      let num = infoConfig.infoList.length;
      let that = this;
      this.timer = setInterval(() => {
        let index = count % num;
        that.infobj = infoConfig.infoList[index];
        count++;
      }, 3000);
    }
  },
  mounted() {
    sessionStorage.getItem("AOTHOR_ID") == "1" &&
    sessionStorage.getItem("ISADMIN") == "0"
      ? (this.menu[1].show = false)
      : null;
    this.ylj = sessionStorage.getItem("AOTHOR_ID") == "0";
    this.$store.state.staticShow = false;
    this.changeInfo();
    this.click_Menu();
  },
  directives: {}
};
</script>



// WEBPACK FOOTER //
// Home_Head.vue?04ca0fa4